// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // The spock namespace's pencil-api (the ingress path is namespace-templated), which
  // serves the AI session routes. Only the API moves: the whiteboard and galactus
  // servers below stay on shared stage. Keep this through master merges.
  serverURL: 'https://staging-apis.pencilapp.com/api/spock',
  firebase: {
    apiKey: 'AIzaSyAHox2vbFGB8hK6so-Hw-isb6EcGlsGOfo',
    authDomain: 'autopush.pencilapp.com',
    databaseURL: 'https://pencil-frontend-staging.firebaseio.com',
    projectId: 'pencil-frontend-staging',
    storageBucket: 'pencil-frontend-staging.appspot.com',
    messagingSenderId: '744637449088',
  },
  vapidPublicKey:
    'BKQc0AG-dGNzKr-hMDRhtkc1fTTznQVRs_M-MrhzVXOqrx2McoEn7OQX4i-EDD0DNBXOE5zSxpROMOp2jyjYrUc',
  sentryKey: 'https://ede17d29b50e449b8e253bb4e3fd759e@sentry.io/1501830',
  sentryOrganisationSlug: 'pencil',
  trainerUrl: 'https://staging.teachertrainers.com',
  fullstoryOrgId: 'YQF1C',
  fayeServer: 'https://staging-apis.pencilapp.com/faye',
  galactusServer: 'https://staging-apis.pencilapp.com',
  whiteboardServer: 'https://staging-apis.pencilapp.com/wb/stage',
  dailyDomain: 'https://pncl.daily.co',
  gtmId: 'GTM-MTTDPBB',
  // Google sign-in, Drive import and YouTube use Spacebar's staging OAuth client
  // (Cloud project spacebar-staging-668873), the staging twin of environment.spacebar.ts.
  // Empty = Google sign-in through Firebase's own popup and client.
  googleSignInClientId: '595651635138-o67p33ofqnnj9s8onnm2n7qdq2624aab.apps.googleusercontent.com',
  youtube: {
    clientId: '595651635138-o67p33ofqnnj9s8onnm2n7qdq2624aab.apps.googleusercontent.com',
  },
  drive: {
    clientId: '595651635138-o67p33ofqnnj9s8onnm2n7qdq2624aab.apps.googleusercontent.com',
    developerKey: 'AIzaSyAq2A_JcABv9KAKc1SHoeHHuCWEmc-7k8w',
    scope: 'https://www.googleapis.com/auth/drive.file',
    // Project number of the Cloud project that owns clientId.
    appId: '595651635138',
  },
  chargebee: {
    site: 'pncl-test',
    publishableKey: 'test_hITzZIyVpsqCgLOSwrhaBlcOchCwgI5D',
  },
  onedrive: {
    clientId: 'eca18dc9-7747-4a65-8f4c-a374b946968d',
  },
  pexels: {
    apiKey: 'RHfXkCr8NALkFLm4ILQBuDFkMcgtjHJunn5ZJoZEgDCTgkBGe97EUVuH',
  },
  clever: {
    clientId: '780956de9d4367dc6cc7',
    redirectURI: 'https://clever-login-staging-hoigjxargq-uc.a.run.app',
  },
  classlink: {
    clientId: 'c1686507119175f02a1b43466faef990216136620337',
    redirectURI: 'https://classlink-login-staging-hoigjxargq-uc.a.run.app',
  },
  appScriptURL: 'https://pencilspaces.app.link/gcaladdon',
  thirdPartyEncryptionSalt: 'Dks983$%KDJS2#$!%567LKjdHDKJksjdwie_shaduE726##DHUASTsgaue',
  googleStorageBucketURL: 'https://storage.googleapis.com/pencil-frontend-staging.appspot.com',
  firebaseAssetsPublicUrl:
    'https://storage.googleapis.com/pencil-frontend-staging.appspot.com/assets/',
  resizedImageUrlPattern:
    'https://firebasestorage.googleapis.com/v0/b/{bucket}/o/resized%2F{fileName}_{width}x{height}?alt=media&token={token}',
  convertedHeicWebpUrlPattern:
    'https://firebasestorage.googleapis.com/v0/b/{bucket}/o/converted%2F{base}.webp?alt=media&token={token}',
  resourceLibraryFolderName: 'resource_library/',
  firebaseMathematicsPath: 'mathematics/',
  firebasePhysicsPath: 'physics/',
  firebaseChemistryPath: 'chemistry/',
  firebaseLiteracyPath: 'literacy/',
  firebaseEmojisAndStickersPath: 'others/',
  firebaseBiologyPath: 'biology/',
  firebaseMusicPath: 'music/',
  resourceLibraryItemsFilePath: 'resource-library-items_1.json',
  phetSimulationsFileName: 'phet_simulations_items_with_categories_.json',
  phetSimulationsPreviewImagesPath: 'phet_simulations_preview_images/',
  bioDigitalModelsFileName: 'bio_digital_items_1.json',
  bioDigitalModelsPreviewImagesPath: 'bio_digital_preview_images/',
  bioDigitalViewerUrl: 'https://human.biodigital.com/widget/?m={modelId}',
  simulcastScreenShare: false,
  svgSpriteName: 'sprite.6fe5a59a.svg',
  picassoServer: 'https://picasso.pencilapp.com:5000',
  marketingUrl: 'https://www.pencilspaces.com',
  oldPdfConverterServer: 'https://staging-apis.pencilapp.com/pdf-converter',
  pdfConverterServer: 'https://staging-apis.pencilapp.com/pdf-converter/convert-pdf-to-images',
  pdfConversionsFolder:
    'https://firebasestorage.googleapis.com/v0/b/pencil-frontend-staging.appspot.com/o/pdf-conversions',
  useDailyScreenShareBalancedPreset: true,
  resourceSignerServer: 'https://staging-apis.pencilapp.com/resource-signer',
  cdnResourcesSignerServer: 'https://staging-apis.pencilapp.com/cdn-resources-signer',
  cdnResourcesDomain: 'https://resources-staging.pencilapp.com',
  openAiServer: 'https://staging-apis.pencilapp.com/pencil-ai-assistant',
  runServiceWorkerLocally: false, // flip this to true to run service-worker locally using http-server (see package.json),
  timeCheckServer: 'https://staging-apis.pencilapp.com/timecheck',
  imageToLatexServer: 'https://staging-apis.pencilapp.com/convertlatex',
  recordingTemplateOrigins: ['https://livekit-template-staging.web.app'],
  // Base URL of the mario-runner service that serves GENERATED apps from GCS.
  // Set per environment; GENERATED Mario apps require this to be configured.
  marioRunnerBaseUrl: 'https://apps-staging.pencilapp.com',
  // The agent's email address per space: SendGrid Inbound Parse on the staging
  // subdomain, <tag>@agent-staging.spacebar.ai (no plus-addressing).
  agentEmailDomain: 'agent-staging.spacebar.ai',
  agentEmailPlusAddressing: false,
  mcpOAuthCallbackOrigins: [
    'https://mcp-staging.pencilapp.com',
    'https://mcp-tier0-test.pencilapp.com',
  ] as string[],
  // Organization admins see the AI data-use toggles (Settings > AI Assist > Data use).
  aiDataUseSettings: true,
};

/*
 * In development mode, for easier debugging, you can ignore zone related error
 * stack frames such as `zone.run`/`zoneDelegate.invokeTask` by importing the
 * below file. Don't forget to comment it out in production mode
 * because it will have a performance impact when errors are thrown
 */
// Import 'zone.js/dist/zone-error';  // Included with Angular CLI.
